import { Provider } from '@angular/core';
import { TOOLBAR_STRATEGY_FACTORY_TOKEN } from './top-toolbar-strategy.token';
import { LazyToolbarStrategyFactoryAdapter } from '../adapters/top-toolbar-strategy-factory.adapter';

export const TOOLBAR_PROVIDERS: Provider[] = [
  {
    provide: TOOLBAR_STRATEGY_FACTORY_TOKEN,
    useClass: LazyToolbarStrategyFactoryAdapter,
  },
];
